var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.952 43.558 c 0 1.097 0.923 1.987 2.061 1.987 h 39.572 c 1.138 0 2.061 -0.89 2.061 -1.987 V 24.683 c 0 -1.097 -0.923 -1.987 -2.061 -1.987 H 13.013 c -1.138 0 -2.061 0.89 -2.061 1.987 V 43.558 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(234,84,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.723 36.268 h -4.412 c -0.549 0 -0.994 -0.445 -0.994 -0.994 V 27.96 c 0 -0.549 0.445 -0.994 0.994 -0.994 h 4.412 c 1.71 0 3.101 1.391 3.101 3.101 v 3.1 C 24.824 34.877 23.432 36.268 21.723 36.268 z M 18.305 34.279 h 3.418 c 0.613 0 1.112 -0.499 1.112 -1.112 v -3.1 c 0 -0.613 -0.499 -1.112 -1.112 -1.112 h -3.418 V 34.279 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.311 41.276 c -0.549 0 -0.994 -0.445 -0.994 -0.994 v -5.008 c 0 -0.549 0.445 -0.994 0.994 -0.994 s 0.994 0.445 0.994 0.994 v 5.008 C 18.305 40.831 17.86 41.276 17.311 41.276 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.861 41.276 h -4.195 c -0.549 0 -0.994 -0.445 -0.994 -0.994 V 27.96 c 0 -0.549 0.445 -0.994 0.994 -0.994 h 4.195 c 1.829 0 3.318 1.488 3.318 3.318 v 7.675 C 37.179 39.788 35.691 41.276 33.861 41.276 z M 30.66 39.287 h 3.201 c 0.733 0 1.329 -0.596 1.329 -1.329 v -7.675 c 0 -0.733 -0.596 -1.329 -1.329 -1.329 H 30.66 V 39.287 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 42.246 41.276 c -0.549 0 -0.994 -0.445 -0.994 -0.994 V 27.96 c 0 -0.549 0.445 -0.994 0.994 -0.994 s 0.994 0.445 0.994 0.994 v 12.321 C 43.241 40.831 42.796 41.276 42.246 41.276 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.764 28.955 h -6.518 c -0.549 0 -0.994 -0.445 -0.994 -0.994 c 0 -0.549 0.445 -0.994 0.994 -0.994 h 6.518 c 0.55 0 0.994 0.445 0.994 0.994 C 49.759 28.51 49.314 28.955 48.764 28.955 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.515 35.115 h -4.269 c -0.549 0 -0.994 -0.445 -0.994 -0.994 s 0.445 -0.994 0.994 -0.994 h 4.269 c 0.55 0 0.994 0.445 0.994 0.994 S 47.065 35.115 46.515 35.115 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 59.376 76.292 h -4.574 V 59.988 c 0 -0.745 -0.582 -1.349 -1.3 -1.349 H 41.15 c -0.718 0 -1.3 0.604 -1.3 1.349 v 16.304 h -4.574 c -0.869 0 -1.304 1.051 -0.69 1.665 l 11.551 11.551 c 0.657 0.657 1.721 0.657 2.378 0 l 11.551 -11.551 C 60.68 77.342 60.245 76.292 59.376 76.292 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(234,84,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.295 19.578 H 63.561 c -2.255 0 -4.09 -1.835 -4.09 -4.091 V 1.755 c 0 -0.824 0.668 -1.492 1.492 -1.492 c 0.824 0 1.492 0.668 1.492 1.492 v 13.732 c 0 0.61 0.496 1.107 1.106 1.107 h 13.734 c 0.824 0 1.492 0.668 1.492 1.492 C 78.787 18.91 78.119 19.578 77.295 19.578 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(124,124,124)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.769 84.395 H 19.947 c -2.395 0 -4.344 -1.949 -4.344 -4.344 V 50.575 c 0 -0.824 0.668 -1.492 1.492 -1.492 c 0.824 0 1.492 0.668 1.492 1.492 v 29.477 c 0 0.751 0.61 1.361 1.361 1.361 h 11.822 c 0.824 0 1.492 0.668 1.492 1.492 C 33.261 83.727 32.593 84.395 31.769 84.395 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(124,124,124)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.705 84.395 H 62.568 c -0.824 0 -1.492 -0.668 -1.492 -1.492 c 0 -0.824 0.668 -1.492 1.492 -1.492 h 12.138 c 0.75 0 1.36 -0.61 1.36 -1.361 V 19.267 c 0 -0.364 -0.142 -0.706 -0.398 -0.962 L 60.744 3.382 c -0.257 -0.256 -0.599 -0.398 -0.962 -0.398 H 19.947 c -0.75 0 -1.361 0.61 -1.361 1.361 v 13.323 c 0 0.824 -0.668 1.492 -1.492 1.492 c -0.824 0 -1.492 -0.668 -1.492 -1.492 V 4.344 C 15.603 1.949 17.552 0 19.947 0 h 39.834 c 1.16 0 2.25 0.452 3.072 1.272 l 14.923 14.924 c 0.821 0.82 1.272 1.911 1.272 3.072 v 60.784 C 79.048 82.446 77.1 84.395 74.705 84.395 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(124,124,124)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.6f6a7833.svg";
export { ForwardRef as ReactComponent };